export default "__VITE_ASSET__VM7J4DP1__"